const debug = window.lcas_debug?.includes('ui-bibz') // ?debug[ui-bibz]=1

import UiBibz from 'ui-bibz-js'

export const uiBibz = new UiBibz()

export function init(element){
  if (debug) console.log('UiBibz.init(%o)', element)
  uiBibz.init(element)
}
